import React from 'react';
import { useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';

export default function Navbar() {
  const { currentUser, logout } = useAuth();
  const navigate = useNavigate();
  const initials = currentUser?.displayName
    ? currentUser.displayName.split(' ').map(n=>n[0]).join('').toUpperCase().slice(0,2)
    : 'U';

  return (
    <nav className="navbar">
      <div className="nav-logo" onClick={() => navigate('/dashboard')} style={{cursor:'pointer'}}>
        <div className="nav-logo-icon">L</div>
        <span className="nav-logo-name">Lend Pesa</span>
      </div>
      {currentUser && (
        <div className="nav-right">
          <div className="nav-avatar">{initials}</div>
          <span className="nav-name" style={{display:'none'}}
            ref={el => el && (el.style.display = window.innerWidth > 500 ? 'block' : 'none')}>
            {currentUser.displayName?.split(' ')[0] || 'User'}
          </span>
          <button className="btn-nav-out" onClick={async () => { await logout(); navigate('/'); }}>Sign Out</button>
        </div>
      )}
    </nav>
  );
}
